import React, { Component } from 'react'
import { Field } from 'redux-form'
import Radio from 'components/Input/Radio'
import Button from 'components/Button'
import { vRequired } from 'components/Input/Input.validations'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import s from './NumbersUsagePlanSelectStep.scss'

export default class NumbersProductSelectStep extends Component {
  render() {
    const { prev, usagePlans, numberType } = this.props

    return (
      <div>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Here, you can optimise your new Classic plan to work the way you do.
        </div>

        {usagePlans.map(plan => (
          <div className={s.outer}>
            <div className={cn(s.heading, sText.heading4)}>{plan.name}</div>
            <div className={sLay['layout-row']}>
              <div className={cn(sLay.flex, s.description)}>
                <div>Local calls: {plan.costLocalCalls}</div>
                <div>National calls: {plan.costNationalCalls}</div>
                <div>Mobile calls: {plan.costMobileCalls}</div>
                <div>Routed to mobile: {plan.costRoutedToMobile}</div>
                <br />
                <div>Minimum Term: {plan.minimumTerm || 'None'}</div>
                <div>Simultaneous Calls: {plan.simultaneousCallsLimit || 'Unlimited'}</div>
              </div>
              <div className={sText.descrip3}>${plan.costPerMonth}/month</div>
              <Field
                className={s.radio}
                component={Radio}
                showTip
                name="productId"
                radioValue={plan.id}
                validate={[vRequired]}
              />
            </div>
          </div>
        ))}
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button color="tertiary" type="submit">
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersUsagePlanSelectStep/NumbersUsagePlanSelectStep.jsx